import { styled } from '@mui/material';
import { lightPalette, up } from '../../../theme';

export const classes = {
  root: 'root',
  filterCloseIcon: 'filterCloseIcon',
  notificationHeading: 'notificationHeading',
  notificationHeadingDivider: 'notificationHeadingDivider',
  mainNotificationContent: 'mainNotificationContent',
  notificationAppBar: 'notificationAppBar',
  noRecordFoundBox: 'noRecordFoundBox',
  moreNotificationsFilterBtn: 'moreNotificationsFilterBtn',
  notificationsList: 'notificationsList',
  notificationFilterPopup: 'notificationFilterPopup',
  notificationFilterPopupSelectBox: 'notificationFilterPopupSelectBox',
  notificationFilterPopupSelect: 'notificationFilterPopupSelect',
  notificationFilterPopupSelectStatus: 'notificationFilterPopupSelectStatus',
  notificationFilterWindowHeader: 'notificationFilterWindowHeader',
  notificationFilterWindowBody: 'notificationFilterWindowBody',
  notificationFilterWindowButton: 'notificationFilterWindowButton',
  notificationFilterWindowButtonApply: 'notificationFilterWindowButtonApply',
  notificationFilterWindowButtonCancel: 'notificationFilterWindowButtonCancel',
  notificationCard: 'notificationCard',
  notificationInvoiceBox: 'notificationInvoiceBox',
  notificationInvoice: 'notificationInvoice',
  notificationInvoiceLink: 'notificationInvoiceLink',
  documentRowTypography: 'documentRowTypography',
  notificationChip: 'notificationChip',
  notificationMessage: 'notificationMessage',
  notificationMoreInfoBtn: 'notificationMoreInfoBtn',
  notificationMoreInfoBtnIcon: 'notificationMoreInfoBtnIcon',
  notificationTime: 'notificationTime',
  notificationTimeIcon: 'notificationTimeIcon',
  moreNotificationsBtn: 'moreNotificationsBtn',
  readAllNotificationsBtn: 'readAllNotificationsBtn',
  SearchField: 'SearchField',
  loaderMainBox: 'loaderMainBox',
  loaderBox: 'loaderBox',
  failedChipColor: 'failedChipColor',
  completedChipColor: 'completedChipColor',
};

export const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    [up('xs')]: {
      height: `calc(100vh - ${theme.spacing(6)});`,
      padding: '20px 14px',
    },
    [up('sm')]: {
      padding: '20px 16px',
    },
    [up('md')]: {
      padding: '23px 18px',
    },
    [up('lg')]: {
      padding: '25px 20px',
    },
    [up('xl')]: {
      padding: '30px 23px',
    },
    [up('xxl')]: {
      padding: '35px 25px',
    },
  },
  [`& .${classes.notificationHeading}`]: {
    marginBottom: '2.7vh',
    color: lightPalette.darkPurple.main,
  },
  [`& .${classes.notificationHeadingDivider}`]: {
    marginBottom: '2.7vh',
  },
  [`& .${classes.mainNotificationContent}`]: {
    padding: '1.5% 0% 1.5% 0%',
    display: 'flex',
    flexDirection: 'column',
    [up('xs')]: {
      height: '70vh',
    },
    [up('sm')]: {
      height: '74vh',
    },
    [up('md')]: {
      height: '74vh',
    },
    [up('lg')]: {
      height: '75vh',
    },
    [up('xl')]: {
      height: '77vh',
    },
    [up('xxl')]: {
      height: '80vh',
    },
  },
  [`& .${classes.notificationAppBar}`]: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
  },
  [`& .${classes.noRecordFoundBox}`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.paperWhite.darker,
    width: '100%',
    height: '40px',
    marginTop: '10px',
  },
  [`& .${classes.moreNotificationsFilterBtn}`]: {
    backgroundColor: theme.palette.paperWhite.darker,
    color: 'black',
    padding: '0px 10px 0px 10px',
    '&:hover': {
      backgroundColor: lightPalette.pastelLavender.main,
    },
  },
  [`& .${classes.notificationsList}`]: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    marginTop: '15px',
    overflow: 'auto',
    maxHeight: '100%',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
      width: '0.4em',
      display: 'none',
    },
    '&::-webkit-scrollbar-track': {
      background: '#D9D9D9',
      borderRadius: '5px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#868686',
      borderRadius: '5px',
    },
  },
  [`& .${classes.filterCloseIcon}`]: {
    cursor: 'pointer',
  },
  [`& .${classes.notificationFilterPopupSelectBox}`]: {
    display: 'flex',
  },
  [`& .${classes.notificationFilterPopupSelect}`]: {
    width: '150px',
  },
  [`& .${classes.notificationFilterPopupSelectStatus}`]: {
    width: '100px',
    marginLeft: '10px',
  },
  [`& .${classes.notificationFilterWindowHeader}`]: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '10px 15px 10px 15px',
    background: lightPalette.deepMidnightBlue.main,
    color: lightPalette.secondaryWhite.main,
    alignItems: 'center',
  },
  [`& .${classes.notificationFilterWindowBody}`]: {
    width: '280px',
    padding: '15px',
  },
  [`& .${classes.notificationFilterWindowButton}`]: {
    marginTop: '10px',
  },
  [`& .${classes.notificationFilterWindowButtonApply}`]: {
    marginRight: '10px',
    height: '25px',
  },
  [`& .${classes.notificationFilterWindowButtonCancel}`]: {
    height: '25px',
    color: 'black',
  },
  [`& .${classes.notificationCard}`]: {
    padding: '20px',
    marginBottom: '15px',
    borderRadius: '10px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  [`& .${classes.notificationInvoiceBox}`]: {
    marginLeft: '10px',
  },
  [`& .${classes.notificationInvoice}`]: {
    width: '70%',
    display: 'flex',
    justifyContent: 'flex-start',
  },
  [`& .${classes.notificationMoreInfoBtn}`]: {
    display: 'flex',
    cursor: 'pointer',
  },
  [`& .${classes.notificationMoreInfoBtnIcon}`]: {
    transform: 'rotate(90deg)',
  },
  [`& .${classes.notificationTime}`]: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '10px',
  },
  [`& .${classes.notificationTimeIcon}`]: {
    marginRight: '5px',
  },
  [`& .${classes.notificationInvoiceLink}`]: {
    width: '70%',
    display: 'flex',
    alignItems: 'center',
  },
  [`& .${classes.notificationChip}`]: {
    marginLeft: '10px',
  },
  [`& .${classes.notificationMessage}`]: {
    marginTop: '10px',
  },
  [`& .${classes.documentRowTypography}`]: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontWeight: '500',
  },
  [`& .${classes.moreNotificationsBtn}`]: {
    backgroundColor: theme.palette.paperWhite.darker,
    '&:hover': {
      backgroundColor: lightPalette.pastelLavender.main,
    },
    [up('xs')]: {
      width: '140px',
      height: '40px',
      marginTop: '15px',
    },
    [up('sm')]: {
      width: '150px',
      height: '40px',
      marginTop: '10px',
    },
    [up('md')]: {
      width: '170px',
      height: '40px',
      marginTop: '7px',
    },
    [up('lg')]: {
      width: '190px',
      height: '50px',
      marginTop: '10px',
    },
    [up('xl')]: {
      width: '220px',
      height: '55px',
      marginTop: '10px',
    },
    [up('xxl')]: {
      width: '240px',
      height: '55px',
      marginTop: '10px',
    },
  },
  [`& .${classes.readAllNotificationsBtn}`]: {
    [up('xs')]: {
      width: '140px',
      height: '30px',
    },
  },
  [`& .${classes.SearchField}`]: {
    padding: 0,
    marginRight: '1vw',
    '& fieldset': {
      border: 'none',
      borderRadius: '5px',
      backgroundColor: theme.palette.paperWhite.darker,
    },
    '& .css-1at8ztp-MuiInputBase-root-MuiOutlinedInput-root': {
      [up('xs')]: {
        // width:"220px",
        height: '20px',
      },
      [up('sm')]: {
        width: '160px',
        height: '25px',
      },
      [up('md')]: {
        width: '185px',
        height: '28px',
      },
      [up('lg')]: {
        width: '190px',
        height: '30px',
      },
      [up('xl')]: {
        width: '195px',
        height: '32px',
      },
      [up('xxl')]: {
        width: '220px',
        height: '40px',
      },
    },
  },
  [`& .${classes.loaderMainBox}`]: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '10px',
  },
  [`& .${classes.loaderBox}`]: {
    marginTop: '20px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [up('xs')]: {
      height: '60vh',
    },
    [up('sm')]: {
      height: '70vh',
    },
    [up('md')]: {
      height: '60vh',
    },
    [up('lg')]: {
      height: '65vh',
    },
    [up('xl')]: {
      height: '70vh',
    },
    [up('xxl')]: {
      height: '80vh',
    },
  },
  [`& .${classes.failedChipColor}`]: {
    background: theme.palette.colorRed.main,
  },
  [`& .${classes.completedChipColor}`]: {
    background: theme.palette.colorGreen.main,
  },
}));
